import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { calculateRepayment, createInputHandler, useGenerateId } from '@lendi-jam/atoms';
import Grid, { Unit, Grid as Grid$1 } from '@lendi-ui/grid';
import Error from '@lendi-ui/icon/Error';
import { Input } from '@lendi-ui/text-input';
import { Heading, Body, link } from '@lendi-ui/typography';
import numeral from 'numeral';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte, between } from '@lendi-ui/breakpoint';
import { Button } from '@lendi-ui/button';
import { fg, bg, color } from '@lendi-ui/color';
import Container from '@lendi-ui/container';
import { my, p, mb, py, mx, px, pr, pt, mt } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { AccordionGroup, Accordion } from '@lendi-ui/accordion';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import Help from '@lendi-ui/icon/Help';
import LendiTooltip from '@lendi-ui/tooltip';

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$1, _templateObject16$1, _templateObject17$1;
var Wrapper$2 = styled(Container)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  ", "\n"])), my('md'));
var Calculator = styled.form(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  background-color: #f8f8f8;\n  border-radius: 5px;\n  ", "\n"])), p({
  lg: 'lg',
  xs: 'md'
}));
var Title = styled(Heading)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  ", "\n"])), mb('sm'));
var StyledHeading$2 = styled(Heading)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  display: block;\n"])));
styled(StyledHeading$2)(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  ", "\n"])), py('sm'));
var StyledUnit = styled(Grid.Unit)(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  row-gap: 6px;\n\n  &:last-child {\n    ", "\n  }\n\n  & > div {\n    width: 100%;\n  }\n"])), mb('md'), mb('nil'));
var StyledButton = styled(Button)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  ", "\n  ", "\n"])), gte('lg')(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n    max-width: 36%;\n  "]))), mx('auto'));
var InputAfter = styled(Body)(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n  font-weight: 100;\n  ", "\n  ", "\n"])), fg('shade.500'), px('xxs'));
var InputBefore$1 = styled(InputAfter)(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n  ", "\n"])), pr('xxxs'));
styled.div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  box-shadow: 1px 2px 6px -3px black;\n  width: 240px;\n  height: 85px;\n  border-radius: 5px;\n  ", "\n  ", "\n\n  ", " {\n    row-gap: 20px;\n\n    ", " {\n      text-align: right;\n    }\n  }\n\n  strong {\n    font-size: 12px;\n  }\n"])), bg('shade.0'), p('sm'), Grid, "".concat(Grid.Unit, ":nth-child(even)"));
var Summary = styled(Body)(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n  ", "\n"])), my('xxs'));
var LayoutLink = styled.a(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  text-decoration: none;\n  display: inline-block;\n"])), link({
  size: 'sm'
}), color('primary.500'));
styled.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n  height: 1px;\n  flex-basis: 100%;\n"])), bg('shade.50'));
styled(Grid.Unit)(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var HelpText = styled(Body)(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 1.15;\n  & a {\n    ", "\n    color: ", ";\n    text-decoration: none;\n    display: inline-block;\n  }\n"])), link({
  size: 'sm'
}), color('primary.500'));
var ResultsWrapper = styled.div(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral(["\n  ", "\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  border-bottom-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  box-sizing: border-box;\n"])), py('md'));

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1;
var StyledAccordionGroup = styled(AccordionGroup)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  ", "\n"])), mb('md'));
var StyledAccordion = styled(Accordion)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  ", "\n  background-color: #003046;\n  border-top: 1px solid ", ";\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n\n  h3 {\n    background-color: #003046;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n\n    button {\n      border-bottom-left-radius: 5px;\n      border-bottom-right-radius: 5px;\n    }\n  }\n"])), fg('shade.0'), color('shade.0'));
var InputBefore = styled(Body)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  font-weight: 100;\n  ", "\n  ", "\n  ", "\n"])), fg('shade.500'), px('xxs'), pr('xxxs'));
var LastHeading = styled(Heading)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  margin: 0;\n  small {\n    font-size: 18px;\n  }\n"])));
var StyledHeading$1 = styled(LastHeading)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  ", "\n"])), mb('xxs'));
var ResponsiveHeading = styled(StyledHeading$1)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  ", ";\n"])), between('xs', 'md')(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n    ", "\n  "])), pt('sm')));
var StyledGridUnit = styled(Unit)(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  row-gap: 8px;\n  display: flex;\n  flex-direction: column;\n"])));
var ResponsiveHeadingCenter = styled(StyledHeading$1)(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  ", ";\n"])), between('xs', 'md')(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n    ", "\n  "])), pt('md')));
styled(Grid$1.Unit)(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  ", " {\n    flex-basis: 100%;\n  }\n"])), Heading);
var StyledGrid$1 = styled(Grid$1)(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var AccordionText = styled(Heading)(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  text-transform: uppercase;\n  ", "\n"])), fg('shade.0'));
var Wrapper$1 = styled.div(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n  background-color: #003046;\n  width: 100%;\n  box-sizing: border-box;\n  ", "\n  z-index: 1;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border: none;\n  ", "\n\n  ", " {\n    height: 100%;\n  }\n\n  ", " {\n    font-weight: 600;\n  }\n"])), fg('shade.0'), p({
  xs: 'xs'
}), Grid$1, Heading);

var repaymentPerMonth = function repaymentPerMonth(equity, fields) {
  return Math.round(calculateRepayment({
    loanAmount: fields.outstandingHomeLoan + equity,
    loanTerm: fields.loanTerm,
    interestRate: fields.interestRate,
    interestOnlyPeriod: 0,
    repaymentFrequency: 12
  }));
};
var MoreInformationAccordion = function MoreInformationAccordion(_ref) {
  var equity = _ref.equity,
    results = _ref.results;
  var initialHomeLoan = results.outstandingHomeLoan + equity;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAccordionOpen = _useState2[0],
    setIsAccordionOpen = _useState2[1];
  var _useState3 = useState(initialHomeLoan),
    _useState4 = _slicedToArray(_useState3, 2),
    newHomeLoan = _useState4[0],
    setNewHomeLoan = _useState4[1];
  var _useState5 = useState(repaymentPerMonth(equity, results)),
    _useState6 = _slicedToArray(_useState5, 2),
    monthlyRepayment = _useState6[0],
    setMonthlyRepayment = _useState6[1];
  var schema = yup.object().shape({
    equityCashOut: yup.mixed().transform(function (string) {
      return numeral(string).value();
    }).test({
      name: 'max',
      message: 'Your cash out amount must be equal to or less than your accessible cash',
      test: function test(equityCashOut) {
        return equityCashOut <= equity;
      }
    })
  });
  var _useForm = useForm({
      resolver: yupResolver(schema),
      reValidateMode: 'onChange',
      mode: 'onChange',
      defaultValues: {
        equityCashOut: equity.toLocaleString()
      }
    }),
    errors = _useForm.errors,
    register = _useForm.register,
    watch = _useForm.watch,
    setValue = _useForm.setValue,
    trigger = _useForm.trigger;
  var equityCashOutHandler = createInputHandler(equity, function () {
    return trigger('equityCashOut');
  });
  var generateId = useGenerateId();
  useEffect(function () {
    setValue('equityCashOut', equity.toLocaleString());
  }, [equity]);
  var intCashOut = watch('equityCashOut');
  useEffect(function () {
    var parsedCashOut = numeral(intCashOut).value() || 0;
    var filteredAmount = parsedCashOut > equity ? equity : parsedCashOut;
    setNewHomeLoan(results.outstandingHomeLoan + filteredAmount);
    setMonthlyRepayment(repaymentPerMonth(filteredAmount, results));
  }, [results, intCashOut]);
  return /*#__PURE__*/jsx(StyledAccordionGroup, {
    variant: "empty",
    children: /*#__PURE__*/jsxs(StyledAccordion, {
      isOpen: isAccordionOpen,
      "data-id": "more-info-accordion",
      children: [/*#__PURE__*/jsx(StyledAccordion.Header, {
        onClick: function onClick() {
          return setIsAccordionOpen(!isAccordionOpen);
        },
        children: /*#__PURE__*/jsx(AccordionText, {
          size: "xxs",
          children: "MORE INFORMATION"
        })
      }), /*#__PURE__*/jsx(Accordion.Content, {
        "data-testid": "accordion-content",
        children: /*#__PURE__*/jsx(Wrapper$1, {
          children: /*#__PURE__*/jsxs(StyledGrid$1, {
            gutter: {
              lg: 'xxl',
              md: 'lg',
              xs: 'md'
            },
            children: [/*#__PURE__*/jsxs(StyledGridUnit, {
              size: {
                sm: 1,
                md: 1 / 3
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: generateId('equityCashOut'),
                children: /*#__PURE__*/jsx(Heading, {
                  size: "xxs",
                  children: "Based on a cash out amount of:"
                })
              }), /*#__PURE__*/jsx(Input, {
                name: "equityCashOut",
                ref: register,
                id: generateId('equityCashOut'),
                isFullWidth: true,
                size: "md",
                type: "text",
                onChange: function onChange() {
                  return undefined;
                },
                onBlur: equityCashOutHandler.blur,
                onFocus: equityCashOutHandler.focus,
                before: /*#__PURE__*/jsx(InputBefore, {
                  children: "$"
                })
              }), errors.equityCashOut && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                children: [/*#__PURE__*/jsx(Error, {
                  color: "error.500"
                }), " ", errors.equityCashOut.message]
              })]
            }), /*#__PURE__*/jsxs(Grid.Unit, {
              size: {
                sm: 1,
                md: 1 / 3
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: generateId('NewHomeLoan'),
                children: /*#__PURE__*/jsx(ResponsiveHeadingCenter, {
                  size: "xxs",
                  children: "Your new loan amount would be:"
                })
              }), /*#__PURE__*/jsx(StyledHeading$1, {
                size: 'lg',
                children: /*#__PURE__*/jsxs("strong", {
                  "data-testid": "new-home-loan",
                  children: ["$", isNaN(newHomeLoan) ? 0 : newHomeLoan.toLocaleString()]
                })
              })]
            }), /*#__PURE__*/jsxs(Grid.Unit, {
              size: {
                sm: 1,
                md: 1 / 3
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: generateId('monthlyRepayment'),
                children: /*#__PURE__*/jsx(ResponsiveHeading, {
                  size: "xxs",
                  children: "Your repayments would be:"
                })
              }), /*#__PURE__*/jsxs(LastHeading, {
                size: "lg",
                children: [/*#__PURE__*/jsxs("strong", {
                  "data-testid": "repayments-per-month",
                  children: ["$", monthlyRepayment.toLocaleString()]
                }), /*#__PURE__*/jsx("small", {
                  children: "/ month"
                })]
              })]
            })]
          })
        })
      })]
    })
  });
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), mx('auto'), between('xs', 'sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    text-align: center;\n  "]))));
var StyledHeading = styled(Heading)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n\n  strong {\n    margin-right: 4px;\n  }\n\n  small {\n    font-size: 14px;\n    display: inline-block;\n\n    ", ";\n  }\n"])), mt('sm'), gte('sm')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      font-size: 18px;\n    "]))));
var Wrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: #003046;\n  width: 100%;\n  box-sizing: border-box;\n  ", "\n  z-index: 1;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border: none;\n  ", "\n\n  ", " {\n    height: 100%;\n  }\n\n  a {\n    align-self: flex-end;\n  }\n\n  ", " {\n    ", "\n  }\n\n  ", " {\n    font-weight: 700;\n  }\n"])), fg('shade.0'), p({
  lg: 'lg',
  xs: 'md'
}), Grid, Body, mt('xxxs'), Heading);
var StyledGrid = styled(Grid)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var SeperatorContainer = styled(Grid.Unit)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), gte('md')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    padding: 0;\n  "]))));
var Seperator = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n  box-sizing: border-box;\n  height: 1px;\n  margin: 28px auto;\n  padding: 0;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), bg('shade.0'), gte('md')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    margin: 0;\n    margin-left: -1px;\n    height: unset;\n    width: 1px;\n    min-height: 100%;\n  "]))), between('xs', 'md')(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    visibility: hidden;\n    margin: 24px auto;\n  "]))));
var FlexUnit = styled(Grid.Unit)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  ", " {\n    flex-basis: 100%;\n  }\n"])), Heading);
var Segment = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  ", "\n\n  ", "\n\n  &:last-child {\n    ", "\n    display: flex;\n  }\n"])), gte('md')(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      width: unset;\n    "]))), gte('lg')(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))), mt({
  xs: 'sm',
  md: 'nil'
}));
styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n\n  & > div {\n    max-width: 45%;\n    width: 50%;\n\n    ", "\n\n    ", "\n\n    &:last-child {\n      ", "\n    }\n  }\n\n  justify-content: space-between;\n"])), gte('sm')(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      max-width: 50%;\n    "]))), gte('lg')(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      width: unset;\n    "]))), mx({
  xs: 'nil',
  lg: 'auto'
}));
var NextSteps = styled(FlexUnit)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  flex-direction: column;\n\n  ", "\n\n  ", "\n"])), between('xs', 'md')(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    justify-content: space-between;\n  "]))), gte('md')(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    row-gap: 20px;\n    justify-content: flex-start;\n  "]))));
var StyledLendiTooltip = styled(LendiTooltip)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  top: -4px;\n  p {\n    font-weight: 400;\n    margin: 0;\n  }\n"])));

var ResultsPanel = function ResultsPanel(_ref) {
  var buttonLink = _ref.buttonLink,
    buttonText = _ref.buttonText,
    equity = _ref.equity,
    resultBody = _ref.resultBody,
    resultHeading = _ref.resultHeading,
    radioTooltipContent = _ref.radioTooltipContent;
  return /*#__PURE__*/jsx(Wrapper, {
    "data-testid": "results-panel-wrapper",
    children: /*#__PURE__*/jsxs(StyledGrid, {
      gutter: "xxxl",
      children: [/*#__PURE__*/jsx(Grid.Unit, {
        size: {
          sm: 1,
          md: 1 / 2
        },
        children: /*#__PURE__*/jsx(Grid, {
          children: /*#__PURE__*/jsxs(FlexUnit, {
            size: 1,
            children: [/*#__PURE__*/jsxs(Heading, {
              size: "sm",
              children: ["Accessible cash", ' ', /*#__PURE__*/jsx(StyledLendiTooltip, {
                content: radioTooltipContent,
                position: "right",
                children: /*#__PURE__*/jsx(Help, {
                  "data-testid": "equity-results-tooltip",
                  height: "20px",
                  width: "20px",
                  color: "primary.600"
                })
              })]
            }), /*#__PURE__*/jsx(StyledHeading, {
              size: "xl",
              children: /*#__PURE__*/jsxs("strong", {
                "data-testid": "equity-display",
                children: ["$", equity.toLocaleString()]
              })
            }), /*#__PURE__*/jsx(Body, {
              size: "sm",
              children: "You could potentially access more, however Lenders Mortgage Insurance may apply."
            })]
          })
        })
      }), /*#__PURE__*/jsx(SeperatorContainer, {
        size: {
          md: 0,
          sm: 1
        },
        children: /*#__PURE__*/jsx(Seperator, {})
      }), /*#__PURE__*/jsx(Grid.Unit, {
        size: {
          md: 1 / 2,
          sm: 1
        },
        children: /*#__PURE__*/jsx(Grid, {
          children: /*#__PURE__*/jsxs(NextSteps, {
            size: {
              md: 3 / 4,
              sm: 1
            },
            children: [/*#__PURE__*/jsxs(Segment, {
              children: [/*#__PURE__*/jsx(Heading, {
                size: "sm",
                children: resultHeading
              }), /*#__PURE__*/jsx(Body, {
                size: "sm",
                children: resultBody
              })]
            }), /*#__PURE__*/jsx(Segment, {
              children: buttonText && buttonLink && /*#__PURE__*/jsx(Button, {
                isFullWidth: true,
                type: "submit",
                variant: "primary",
                size: "md",
                href: embedMarketingTrackingIntoURL(buttonLink),
                children: buttonText
              })
            })]
          })
        })
      })]
    })
  });
};

var calculateEquity = function calculateEquity(estimatedPropertyValue, outstandingHomeLoan) {
  return estimatedPropertyValue * 0.8 - outstandingHomeLoan;
};

var exampleHelpText = /*#__PURE__*/jsxs(Fragment, {
  children: ["Don't know your property's value? Get a", ' ', /*#__PURE__*/jsx(LayoutLink, {
    href: "https://www.lendi.com.au/property-report/",
    children: "free property report"
  })]
});
var DEFAULT_VALUES = {
  estimatedPropertyValue: '750,000',
  outstandingHomeLoan: '450,000',
  interestRate: '6.09',
  loanTerm: 25
};
var MAXIMUM_VALUES = {
  estimatedPropertyValue: 100000000,
  outstandingHomeLoan: 80000000,
  loanTerm: 30,
  interestRate: 20
};
var schema = yup.object().shape({
  estimatedPropertyValue: yup.mixed().transform(function (string) {
    return numeral(string).value();
  }).test({
    name: 'min',
    message: 'Property value must be greater than $50,000',
    test: function test(estimatedPropertyValue) {
      return estimatedPropertyValue > 50000;
    }
  }).test({
    name: 'max',
    message: 'Property value must be equal to or less than $100 million',
    test: function test(estimatedPropertyValue) {
      return estimatedPropertyValue <= MAXIMUM_VALUES.estimatedPropertyValue;
    }
  }),
  outstandingHomeLoan: yup.mixed().transform(function (string) {
    return numeral(string).value();
  }).test({
    name: 'min',
    message: 'Outstanding loan amount must be greater than $5,000',
    test: function test(outstandingHomeLoan) {
      return outstandingHomeLoan > 5000;
    }
  }).test({
    name: 'max',
    message: 'Outstanding loan amount must be equal to or less than $80 million',
    test: function test(outstandingHomeLoan) {
      return outstandingHomeLoan <= MAXIMUM_VALUES.outstandingHomeLoan;
    }
  }),
  interestRate: yup.number().typeError('Interest rate must be greater than 0%').min(0.01, 'Interest rate must be greater than 0%').max(MAXIMUM_VALUES.interestRate, 'Interest rate must be equal to or less than 20%').required('Interest rate must be greater than 0%'),
  loanTerm: yup.number().typeError('Loan term must be greater than 0 years').min(1, 'Loan term must be greater than 0 years').max(MAXIMUM_VALUES.loanTerm, 'Loan term must be equal to or less than 30 years').integer('Please enter a whole number').required('Loan term must be greater than 0 years')
});
var EquityCalculator = function EquityCalculator(_ref) {
  var buttonText = _ref.buttonText,
    buttonLink = _ref.buttonLink,
    calculatorHeading = _ref.calculatorHeading,
    helpText = _ref.helpText,
    disclaimer = _ref.disclaimer,
    resultBody = _ref.resultBody,
    resultHeading = _ref.resultHeading,
    radioTooltipContent = _ref.radioTooltipContent;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    results = _useState2[0],
    setResults = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    equityCashOut = _useState4[0],
    setEquityCashOut = _useState4[1];
  var generateId = useGenerateId();
  var _useForm = useForm({
      resolver: yupResolver(schema),
      reValidateMode: 'onChange',
      mode: 'onChange',
      defaultValues: DEFAULT_VALUES
    }),
    errors = _useForm.errors,
    handleSubmit = _useForm.handleSubmit,
    register = _useForm.register,
    reset = _useForm.reset,
    trigger = _useForm.trigger,
    _useForm$formState = _useForm.formState,
    isValid = _useForm$formState.isValid,
    isDirty = _useForm$formState.isDirty,
    isSubmitted = _useForm$formState.isSubmitted;
  var estimatedPropertyValueHandler = createInputHandler(MAXIMUM_VALUES.estimatedPropertyValue, function () {
    return trigger('estimatedPropertyValue');
  });
  var outstandingHomeLoanHandler = createInputHandler(MAXIMUM_VALUES.outstandingHomeLoan, function () {
    return trigger('outstandingHomeLoan');
  });
  var loanTermHandler = createInputHandler(MAXIMUM_VALUES.loanTerm, function () {
    return trigger('loanTerm');
  });
  var interestRateHandler = createInputHandler(MAXIMUM_VALUES.interestRate, function () {
    return trigger('interestRate');
  }, '0.00');
  var onSubmit = function onSubmit(_ref2) {
    var estimatedPropertyValue = _ref2.estimatedPropertyValue,
      outstandingHomeLoan = _ref2.outstandingHomeLoan,
      interestRate = _ref2.interestRate,
      loanTerm = _ref2.loanTerm;
    reset(_objectSpread(_objectSpread({}, DEFAULT_VALUES), {}, {
      estimatedPropertyValue: estimatedPropertyValue.toLocaleString(),
      outstandingHomeLoan: outstandingHomeLoan.toLocaleString(),
      interestRate: numeral(interestRate).format('0.00'),
      loanTerm: loanTerm
    }));
    setEquityCashOut(function () {
      return calculateEquity(estimatedPropertyValue, outstandingHomeLoan);
    });
    setResults({
      estimatedPropertyValue: estimatedPropertyValue,
      outstandingHomeLoan: outstandingHomeLoan,
      interestRate: interestRate,
      loanTerm: loanTerm
    });
  };
  useEffect(function () {
    if (equityCashOut !== null && equityCashOut < 0) setEquityCashOut(0);
  }, [equityCashOut]);
  return /*#__PURE__*/jsxs(Wrapper$2, {
    children: [/*#__PURE__*/jsxs(Calculator, {
      onSubmit: handleSubmit(onSubmit),
      children: [calculatorHeading && /*#__PURE__*/jsx(Title, {
        size: 'sm',
        children: calculatorHeading
      }), /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsxs(StyledUnit, {
          size: {
            lg: 1 / 4,
            sm: 1 / 2,
            xs: 1
          },
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: generateId('estimatedPropertyValue'),
            children: /*#__PURE__*/jsx(StyledHeading$2, {
              size: "xxs",
              children: "Estimated property value"
            })
          }), /*#__PURE__*/jsx(Input, {
            ref: register,
            id: generateId('estimatedPropertyValue'),
            name: "estimatedPropertyValue",
            isFullWidth: true,
            size: "md",
            type: "text",
            onChange: function onChange() {
              return undefined;
            },
            "aria-label": "estimated-property-value",
            onBlur: estimatedPropertyValueHandler.blur,
            onFocus: estimatedPropertyValueHandler.focus,
            before: /*#__PURE__*/jsx(InputBefore$1, {
              children: "$"
            })
          }), errors.estimatedPropertyValue && /*#__PURE__*/jsxs(Body, {
            color: "error.500",
            size: "xs",
            "aria-role": "estimated-property-value-error",
            children: [/*#__PURE__*/jsx(Error, {
              color: "error.500"
            }), " ", errors.estimatedPropertyValue.message]
          })]
        }), /*#__PURE__*/jsxs(StyledUnit, {
          size: {
            lg: 1 / 4,
            sm: 1 / 2,
            xs: 1
          },
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: generateId('outstandingHomeLoan'),
            children: /*#__PURE__*/jsx(StyledHeading$2, {
              size: "xxs",
              children: "Outstanding loan amount"
            })
          }), /*#__PURE__*/jsx(Input, {
            ref: register,
            isFullWidth: true,
            id: generateId('outstandingHomeLoan'),
            name: "outstandingHomeLoan",
            size: "md",
            type: "text",
            onChange: function onChange() {
              return undefined;
            },
            "aria-label": "outstanding-home-loan",
            onBlur: outstandingHomeLoanHandler.blur,
            onFocus: outstandingHomeLoanHandler.focus,
            before: /*#__PURE__*/jsx(InputBefore$1, {
              children: "$"
            })
          }), errors.outstandingHomeLoan && /*#__PURE__*/jsxs(Body, {
            color: "error.500",
            size: "xs",
            "aria-role": "outstanding-home-loan-error",
            children: [/*#__PURE__*/jsx(Error, {
              color: "error.500"
            }), " ", errors.outstandingHomeLoan.message]
          })]
        }), /*#__PURE__*/jsxs(StyledUnit, {
          size: {
            lg: 1 / 4,
            sm: 1 / 2,
            xs: 1
          },
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: generateId('interestRate'),
            children: /*#__PURE__*/jsx(StyledHeading$2, {
              size: "xxs",
              children: "Interest rate"
            })
          }), /*#__PURE__*/jsx(Input, {
            name: "interestRate",
            id: generateId('interestRate'),
            ref: register,
            isFullWidth: true,
            size: "md",
            onChange: function onChange() {
              return undefined;
            },
            "aria-label": "interest-rate",
            onBlur: interestRateHandler.blur,
            onFocus: interestRateHandler.focus,
            type: "text",
            after: /*#__PURE__*/jsx(InputAfter, {
              children: "%"
            })
          }), errors.interestRate && /*#__PURE__*/jsxs(Body, {
            color: "error.500",
            size: "xs",
            "aria-role": "interest-rate-error",
            children: [/*#__PURE__*/jsx(Error, {
              color: "error.500"
            }), " ", errors.interestRate.message]
          })]
        }), /*#__PURE__*/jsxs(StyledUnit, {
          size: {
            lg: 1 / 4,
            sm: 1 / 2,
            xs: 1
          },
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: generateId('loanTerm'),
            children: /*#__PURE__*/jsx(StyledHeading$2, {
              size: "xxs",
              children: "Loan term"
            })
          }), /*#__PURE__*/jsx(Input, {
            name: "loanTerm",
            id: generateId('loanTerm'),
            ref: register,
            isFullWidth: true,
            size: "md",
            onChange: function onChange() {
              return undefined;
            },
            "aria-label": "loan-term",
            onBlur: loanTermHandler.blur,
            onFocus: loanTermHandler.focus,
            type: "text",
            after: /*#__PURE__*/jsx(InputAfter, {
              children: "years"
            })
          }), errors.loanTerm && /*#__PURE__*/jsxs(Body, {
            color: "error.500",
            size: "xs",
            "aria-role": "loan-term-error",
            children: [/*#__PURE__*/jsx(Error, {
              color: "error.500"
            }), " ", errors.loanTerm.message]
          })]
        }), /*#__PURE__*/jsx(StyledUnit, {
          size: {
            lg: 1 / 2,
            sm: 1
          },
          children: /*#__PURE__*/jsx(HelpText, {
            children: helpText
          })
        }), /*#__PURE__*/jsx(StyledUnit, {
          size: 1,
          children: /*#__PURE__*/jsx(StyledButton, {
            "data-testid": "calculate-button",
            type: "submit",
            variant: "primary",
            size: "md",
            isDisabled: !(isValid && (isDirty || !isSubmitted)),
            children: "Calculate"
          })
        })]
      })]
    }), results && equityCashOut !== null && equityCashOut >= 0 ? /*#__PURE__*/jsxs(ResultsWrapper, {
      children: [/*#__PURE__*/jsx(ResultsPanel, {
        buttonLink: buttonLink,
        buttonText: buttonText,
        resultBody: resultBody,
        resultHeading: resultHeading,
        equity: equityCashOut,
        radioTooltipContent: radioTooltipContent
      }), /*#__PURE__*/jsx(MoreInformationAccordion, {
        equity: equityCashOut,
        results: results
      }), disclaimer && /*#__PURE__*/jsx(Summary, {
        children: disclaimer
      })]
    }) : null]
  });
};

export { EquityCalculator as default, exampleHelpText };
